export function getTreasureDistance(coordinates, treasureLocations) {
    return Math.min(...treasureLocations
        .map((loc) => Math.abs(loc.x - coordinates.x) + Math.abs(loc.y - coordinates.y))
        // filter out the 0 distance to the treasure itself
        .filter((n) => n > 0));
}
